module.exports = __webpack_public_path__ + "img/banner-2.3f8c5815.jpg";